import React, { useState } from "react";
import { getStoredItem } from "../../config/storageUtils";
import { profileFormFields } from "../../forms/profileFields";
import {
  camelCaseToLabel,
  formatDate,
  validateField,
  validateSingleSectionFormData,
} from "../../utils/utils";
import Button from "../common/Button";
import DataFormField from "../common/DataFormField";
import { useNavigate } from "react-router-dom";
import api from "../../api/ApiService";

const ProfileForm = () => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, type, files, value } = e.target;

    const newValue = type === "file" ? files[0] : value;

    setFormData((prev) => ({ ...prev, [name]: newValue }));
    setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    let fieldConfig;
    profileFormFields.forEach((section) => {
      section.fields.forEach((field) => {
        if (field.inputProps.name === name) {
          fieldConfig = field;
        }
      });
    });

    if (fieldConfig?.inputProps?.validation) {
      const label = fieldConfig.label || camelCaseToLabel(name);
      const error = validateField(
        fieldConfig.inputProps.validation,
        value,
        label
      );
      setErrors((prev) => ({ ...prev, [name]: error }));
    }
  };

  const handleSubmit = async () => {
    const { errors, isValid } = validateSingleSectionFormData(
      profileFormFields,
      formData
    );
    setErrors(errors);
    if (isValid) {
      const resp = await api.post("/manual-data1", {
        ...formData,
        city: "Dehradun",
      });

      if (resp.code === 200) {
        navigate("/dashboard");
      }
    }
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {profileFormFields?.map((section, sectionIndex) => (
          <React.Fragment key={sectionIndex}>
            {section.fields?.map((field, fieldIndex) => (
              <DataFormField
                key={`${sectionIndex}-${fieldIndex}`}
                labelClass="block text-sm font-medium mb-1"
                divClass={field?.divClass}
                label={field?.label}
                htmlFor={field?.htmlFor}
                error={errors[field.inputProps.name]}
                inputClass={
                  field.inputProps.type === "checkbox"
                    ? "h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                    : "w-full border rounded px-3 py-2 text-sm"
                }
                inputProps={{
                  required: field.inputProps.required || "false",
                  type: field.inputProps.type || "text",
                  name: field.inputProps.name,
                  id: field.inputProps.name,
                  placeholder: field.inputProps.placeholder || "",
                  disabled: field.inputProps.disabled || false,
                  value:
                    field.inputProps.type === "date"
                      ? formatDate(formData[field.inputProps.name])
                      : field.inputProps.type === "checkbox"
                      ? undefined // ✅ checkboxes don’t need value
                      : formData[field.inputProps.name] || "",
                  checked:
                    field.inputProps.type === "checkbox"
                      ? formData[field.inputProps.name] === true ||
                        formData[field.inputProps.name] === "1" ||
                        formData[field.inputProps.name] === 1
                      : undefined,
                  onChange: handleChange,
                  onBlur: handleBlur,
                  options: field.inputProps.options || [],
                  maxLength: field.inputProps.maxLength || 255,
                  ...(field.inputProps.min
                    ? { min: field.inputProps.min }
                    : {}),
                  ...(field.inputProps.max
                    ? { max: field.inputProps.max }
                    : {}),
                  description: field.inputProps.description || "",
                  formatDocument: field.inputProps.formatDocument || null
                }}
                formData={formData}
              />
            ))}
          </React.Fragment>
        ))}
      </div>

      <div className="flex justify-end mt-4">
        <Button className="bg-btn px-6 py-2 rounded" onClick={handleSubmit}>
          Submit
        </Button>
      </div>
    </>
  );
};

export default ProfileForm;
